import React, { useEffect, useId, useMemo, useState } from 'react'
import './CatalogPage.scss'
import { Modal, useMediaQuery } from '@mui/material'
import CatalogPageHead from './CatalogPageHead/CatalogPageHead'
import CUIRadioButton from './CUIRadioButton/CUIRadioButton'
import { useNavigate, useParams } from 'react-router'

import { ReactComponent as GridOnIcon } from '../components/assets/CatalogPage/GridOnCatalogPageMode.svg'
import { ReactComponent as GridOffIcon } from '../components/assets/CatalogPage/GridOffCatalogPageMode.svg'
import { ReactComponent as LineOnIcon } from '../components/assets/CatalogPage/LineOnCatalogPageMode.svg'
import { ReactComponent as LineOffIcon } from '../components/assets/CatalogPage/LineOffCatalogPageMode.svg'
import { ReactComponent as CarIcon } from '../components/assets/CatalogPage/CarCatalogPageHead.svg'
import { ReactComponent as ZoomIcon } from '../components/assets/CatalogPage/ZoomIcon.svg'
import { digitalAppApi } from '../../store/services/digitalAppApi'
import CatalogPageCard from './CatalogPageCard/CatalogPageCard'
import CatalogPageFilter from './CatalogPageFilter/CatalogPageFilter'
import replaceAccent from '../../hooks/replaceAccent'
import { mainApi } from '../../store/services/mainApi'
import { useSelector } from 'react-redux'
import CatalogPageCartModal from './CatalogPageCartModal/CatalogPageCartModal'
import CatalogPageNavigator from './CatalogPageNavigator/CatalogPageNavigator'
import { catalogs } from '../../constants/catalogs'

const optionsMode = [
  { name: 'TPO', color: '#5FC56E ' },
  // { name: <span style={{ color: '#fce600', fontWeight: 'bold', fontSize: '18px' }}>M</span>, color: '#155dfc ' },
]
const optionView = [
  { iconOn: <GridOnIcon />, iconOff: <GridOffIcon />, view: 'grid' },
  { iconOn: <LineOnIcon />, iconOff: <LineOffIcon />, view: 'line' },
]

const CatalogPage = () => {
  const mobileView = useMediaQuery('(max-width: 798px)')
  const navigate = useNavigate()
  const tradeName = useParams().tradeName
  const platform = useParams().platform
  const catalogPresonal = catalogs?.find((el) => el?.link === platform)
  console.log(catalogPresonal);
  const uid = useId()

  const allItemsCartCatalogPage = useSelector((state) => state.allItemsCart.allItemsCart)?.filter((item) => item?.sku?.includes(catalogPresonal?.skus))

  const [helpModal, setHelpModal] = useState(false)
  const [view, setView] = useState(optionView[1]?.view)
  const [openFilter, setOpenFilter] = useState(false)
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [filters, setFilters] = useState({
    category: [],
    brands: [],
    search: '',
    delivery: [],
  })

  const { data: contact, isLoading: isLoadingContact } = mainApi.useGetBuisnessContactByTradeNameQuery(tradeName, {
    skip: !tradeName || mobileView,
  })
  const { data: catalogPersonal, isLoading: isLoadingMarcoPersonal } = digitalAppApi.useGetMakroPersonalQuery(tradeName, { skip: !tradeName })

  const filteredItems = useMemo(() => {
    if (!catalogPersonal?.data) return []

    return catalogPersonal.data
      ?.filter((item) => {
        if (!item?.sku?.includes(catalogPresonal?.skus)) return false
        // 1. Фильтр по поиску (регистронезависимый)
        const matchesSearch =
          replaceAccent(item?.name)?.toLowerCase()?.includes(replaceAccent(filters?.search)?.toLowerCase()) ||
          replaceAccent(item?.brand)?.toLowerCase()?.includes(replaceAccent(filters?.search)?.toLowerCase())

        // 2. Фильтр по категории (если категория выбрана)
        const itemCategories = item?.category ? item.category.split(',').map((cat) => cat.trim()) : []

        const matchesCategory = filters?.category?.length === 0 || itemCategories?.some((cat) => filters?.category?.includes(cat))

        // 3. Фильтр по брендам (если выбрано хотя бы один бренд)
        const matchesBrand = filters?.brands?.length === 0 || filters?.brands?.includes(item?.brand)

        // 4. Фильтр по доставке (замените 'hasDelivery' на ваше поле из API)
        const matchesDelivery = !filters?.courierDelivery || item?.hasDelivery === true

        return matchesSearch && matchesCategory && matchesBrand && matchesDelivery
      })
      ?.map((item) => ({ ...item, IVACP: item?.IVA }))
  }, [catalogPersonal, filters, catalogPresonal])

  useEffect(() => {
    console.log(filteredItems)
  }, [filteredItems])

  return mobileView ? (
    <div className='CatalogPageMobile'>
      <CatalogPageHead setOpenFilter={setOpenFilter} setIsCartOpen={setIsCartOpen} filters={filters} setFilters={setFilters} />
      <CatalogPageNavigator />
      <Modal open={openFilter} onClose={() => setOpenFilter(false)}>
        <CatalogPageFilter
          sx={{ position: 'fixed', left: 0, top: 0, height: '100dvh' }}
          onClose={() => setOpenFilter(false)}
          filters={filters}
          setFilters={setFilters}
          items={catalogPersonal?.data?.length > 0 ? catalogPersonal?.data : []}
        />
      </Modal>
      <CatalogPageCartModal open={isCartOpen} onClose={() => setIsCartOpen(false)} />
      <div className='rw'>
        <CUIRadioButton
          sx={{ height: '38px', elem: { width: '38px', height: '38px', padding: '0 10px' } }}
          options={optionView}
          value={view}
          onChange={(e) => setView(e.view)}
          getOptionLabel={(e) => (e.view == view ? e?.iconOn : e.iconOff)}
          getOptionValue={(e) => e.view}
          color={catalogPresonal?.color}
        />

        <CUIRadioButton
          sx={{ height: '38px', elem: { width: '100%', height: '38px', padding: '0 10px' } }}
          options={[...optionsMode, ...catalogs]}
          value={catalogs?.find((el) => el?.link === platform)?.name}
          onChange={() => navigate('/category/' + tradeName)}
          getOptionLabel={(e) => e?.name}
          getOptionValue={(e) => e?.name}
        />

        <button
          className='CatalogPageBtn'
          onClick={() => {
            setHelpModal(true)
          }}
        >
          Condiciones
        </button>
        <Modal open={helpModal} onClose={() => setHelpModal(false)}>
          <div className='CatalogPageMobile__CatalogPageHelp' onClick={() => setHelpModal(false)}>
            <span>X</span>
            <img src={catalogPresonal?.condicionesImg} alt='' />
            {catalogPresonal?.condiciones}
          </div>
        </Modal>
      </div>

      <div className='rw' style={{ flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
        {isLoadingMarcoPersonal
          ? Array(8).map((_, index) => <CatalogPageCard key={uid + index} view={view} />)
          : filteredItems?.length > 0
          ? filteredItems?.map((item, index) => <CatalogPageCard key={uid + index} item={item} view={view} />)
          : null}
      </div>
    </div>
  ) : (
    <div className='CatalogPageWeb'>
      <div className='cl' style={{ gap: '25px', maxWidth: '1140px' }}>
        <CatalogPageNavigator />
        <CatalogPageCartModal open={isCartOpen} onClose={() => setIsCartOpen(false)} />
        <div className='rw CatalogPageWeb__head'>
          {!isLoadingContact && contact?.name && <h2>{contact?.name}</h2>}
          <CUIRadioButton
            sx={{ height: '38px', elem: { width: '38px', height: '38px', padding: '0 10px' } }}
            options={optionView}
            value={view}
            onChange={(e) => setView(e.view)}
            getOptionLabel={(e) => (e.view == view ? e?.iconOn : e.iconOff)}
            getOptionValue={(e) => e.view}
            color={catalogPresonal?.color}
          />
          <CUIRadioButton
            sx={{ height: '38px', elem: { width: '100%', height: '38px', padding: '0 10px' } }}
            options={[ ...optionsMode, ...catalogs]}
            value={catalogs?.find((el) => el?.link === platform)?.name}
            onChange={() => navigate('/category/' + tradeName)}
            getOptionLabel={(e) => e?.name}
            getOptionValue={(e) => e?.name}
          />

          <button
            className='CatalogPageBtn'
            onClick={() => {
              setHelpModal(true)
            }}
          >
            Condiciones
          </button>
          <Modal open={helpModal} onClose={() => setHelpModal(false)}>
            <div className='CatalogPageWeb__CatalogPageHelp' onClick={() => setHelpModal(false)}>
              <span>X</span>
              <img src={'https://i.imgur.com/GZKkyBU.png'} alt='' />
              ¡Este es un presupuesto básico!
              <br />
              <br />
              Negociaremos con cada cliente individualmente.
              <br />
            </div>
          </Modal>

          <div className='Search'>
            <input
              type='text'
              className='Search__input'
              value={filters?.search}
              placeholder='Search...'
              onChange={(e) => {
                setFilters((prew) => ({ ...prew, search: e.target.value }))
              }}
            />
            <ZoomIcon />
          </div>

          <div className='Cart' onClick={() => setIsCartOpen(true)} 
            style={catalogPresonal ? { background: catalogPresonal?.color } : { }}>
            <div className='Cart__total'>
              €{allItemsCartCatalogPage?.reduce((acc, curr) => acc + curr?.spoPrice * (curr?.quantity || 0), 0)?.toFixed(2)}
            </div>
            <div className='Cart__display'>
              <CarIcon width={16} height={16} />
              <span>{allItemsCartCatalogPage?.length}</span>
            </div>
          </div>
        </div>
        <div className='rw'>
          <CatalogPageFilter
            sx={{ height: 'max-content' }}
            filters={filters}
            setFilters={setFilters}
            items={catalogPersonal?.data?.length > 0 ? catalogPersonal?.data : []}
          />
          <div className='rw' style={{ flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
            {isLoadingMarcoPersonal
              ? Array(8).map((_, index) => <CatalogPageCard key={uid + index} view={view} />)
              : filteredItems?.length > 0
              ? filteredItems?.map((item, index) => <CatalogPageCard key={uid + index} item={item} view={view} />)
              : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CatalogPage
